import { useContext, useEffect } from 'react';
import { LoadingIndicator, Sizes } from '@chr/navisphereonline-shared-components';
import { AuthContext, ErrorContext } from '@chr/navisphereonline-shared-components';
import { storeJwt, LinkService, isAuthed, getUserProfileV2Async, getUserProfileV2Local } from '@chr/online-shared-microsite-core';
import { windowReload } from './window-helpers';

const renderLoading = () => {
  return <LoadingIndicator size={Sizes.Medium} data-test="loading"/>;
};

export const RequiresAuth = (props: any) => {
  const authClient = useContext(AuthContext);
  const errorContext = useContext(ErrorContext);

  useEffect(() => {
    const login = async () => {
      try {
        const authResponse = await authClient.ensureAuthed();
        if (authResponse.identityToken) {
          storeJwt(authResponse.accessToken, authResponse.identityToken);
        }
        const forceRefresh = true;
        await getUserProfileV2Async(forceRefresh);
        windowReload();
      } catch (err: any) {
        if (err?.errorCode === "inactive_session") {
          await authClient.login();
        } else {
          errorContext.setError(err);
        }
      }
    };

    const getUserData = async () => {
      // only call getUserProfileV2Async if local storage user data is missing
      // this gets call everytime a route in this microsite is loaded.
      if (getUserProfileV2Local() === null) {
        const forceRefresh = true;
        await getUserProfileV2Async(forceRefresh);
      }
      // it uses cache if application links already exists
      await LinkService.getLinks();
    }

    if (authClient) {
      if (!isAuthed()) {
        login();
      } else {
        getUserData();
      }
    }
  }, [authClient, errorContext]);

  return isAuthed() ? props.children : renderLoading();
};

export const Unauthed = (ComponentToRender: any) => {
  return (props: JSX.IntrinsicAttributes) => (
    <ComponentToRender {...props} />
  );
};

export const Authed = (ComponentToRender: any) => {
  return (props: JSX.IntrinsicAttributes) => (
    <RequiresAuth>
      <ComponentToRender {...props} />
    </RequiresAuth>
  );
};
